import React, { Fragment, useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Link, useParams } from 'react-router-dom';
import { getProductDetails } from '../../../api/redux/slices/Admin';
import { icons } from '../../../assets/icons';
import { LoaderComponent } from '../../../helpers/components/loader';
import './index.scss';

const ProductDetails = () => {
	const params = useParams();
	const dispatch = useDispatch();
	const token = localStorage.getItem('accesstoken');
	const [detailProduct, setDetailProduct] = useState({});
	const [loading, setLoading] = useState(false);

	// -------------------------- get products list and filtering ----------------------------//
	const stableDispatch = useCallback(() => {
		setLoading(true);
		dispatch(
			getProductDetails({
				token: token,
				id: params.id,
			}),
		)
			.unwrap()
			.then((res) => setDetailProduct(res.data))
			.finally(() => setLoading(false));
	}, [dispatch, token, params]);

	useEffect(() => {
		if (token) {
			stableDispatch();
		}
	}, [stableDispatch, token]);

	if (loading) {
		return <LoaderComponent />;
	}
	return (
		<div id='product-details'>
			<header className="pdp-header">
				<div className="pdp-header__brand">
					<span className="pdp-header__icon">📦</span>
					<h1 className="pdp-header__title">Détails du Produit</h1>
				</div>
				<div className="pdp-header__actions">
					<Link to={`/admin/products/${params.page}`} className="pdp-back-btn">
						<icons.IoIosArrowBack />
						<span>Retour aux produits</span>
					</Link>
					<Link to={`/admin/products/product_update/${params.page}/${params.id}`}>
						<button className="pdp-edit-btn">
							<icons.FiEdit />
							<span>Modifier produit</span>
						</button>
					</Link>
				</div>
			</header>

			<Fragment>
				<div className='pdp-content'>
					<div className='pdp-card pdp-main-card'>
						<div className='pdp-image-section'>
							<div className='pdp-image-wrapper'>
								<img
									src={detailProduct?.image?.secure_url}
									alt={detailProduct?.designation}
								/>
							</div>
						</div>
						<div className='pdp-info-section'>
							<h2>{detailProduct?.designation}</h2>
							<p className='pdp-description'>{detailProduct?.description || 'Aucune description disponible'}</p>
							<div className='pdp-badges'>
								<span className='pdp-badge category'>
									<icons.FiTag />
									{detailProduct?.category?.designation || '-'}
								</span>
								<span className='pdp-badge'>
									<icons.FiHash />
									{detailProduct?.reference || '-'}
								</span>
							</div>
						</div>
					</div>

					<div className='pdp-grid'>
						<div className='pdp-card'>
							<h3 className='pdp-card-title'>
								<icons.FiInfo />
								Informations Générales
							</h3>
							<div className='pdp-table-wrapper'>
								<table className='pdp-table'>
									<tbody>
										<tr>
											<td className='pdp-label'>Référence</td>
											<td className='pdp-value'>{detailProduct?.reference || '-'}</td>
										</tr>
										<tr>
											<td className='pdp-label'>Code à barre</td>
											<td className='pdp-value'>{detailProduct?.barCode || '-'}</td>
										</tr>
										<tr>
											<td className='pdp-label'>Catégorie</td>
											<td className='pdp-value'>{detailProduct?.category?.designation || '-'}</td>
										</tr>
										<tr>
											<td className='pdp-label'>Contenance</td>
											<td className='pdp-value'>{detailProduct?.capacity || '-'}</td>
										</tr>
										<tr>
											<td className='pdp-label'>Nb pièces/carton</td>
											<td className='pdp-value'>{detailProduct?.nb_cardboard_piece || '-'}</td>
										</tr>
										<tr>
											<td className='pdp-label'>Couleur</td>
											<td className='pdp-value'>{detailProduct?.color || '-'}</td>
										</tr>
										<tr>
											<td className='pdp-label'>Matière</td>
											<td className='pdp-value'>{detailProduct?.material || '-'}</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>

						<div className='pdp-card'>
							<h3 className='pdp-card-title'>
								<icons.FiDollarSign />
								Prix & Dimensions
							</h3>
							<div className='pdp-table-wrapper'>
								<table className='pdp-table'>
									<tbody>
										<tr>
											<td className='pdp-label'>Volume</td>
											<td className='pdp-value'>{detailProduct?.volume || '-'} m³</td>
										</tr>
										<tr>
											<td className='pdp-label'>Prix HT</td>
											<td className='pdp-value'>{detailProduct?.prise_HT || '-'} DT</td>
										</tr>
										<tr>
											<td className='pdp-label'>TVA</td>
											<td className='pdp-value'>{detailProduct?.Tva || '-'} %</td>
										</tr>
										<tr className='pdp-highlight'>
											<td className='pdp-label'>Prix Détaillant</td>
											<td className='pdp-value'>{detailProduct?.Retail_Price || '-'} DT</td>
										</tr>
										<tr className='pdp-highlight'>
											<td className='pdp-label'>Prix Grossiste</td>
											<td className='pdp-value'>{detailProduct?.Wholesale_Price || '-'} DT</td>
										</tr>
										<tr className='pdp-highlight'>
											<td className='pdp-label'>Prix Grande Surface</td>
											<td className='pdp-value'>{detailProduct?.Monoprix_Price || '-'} DT</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
					</div>
				</div>
			</Fragment>
		</div>
	);
};

export default ProductDetails;